const vouchers = (state = [], action) => {
  switch (action.type) {
    case 'SET_VOUCHERS':
      return action.vouchers
    default:
      return state
  }
}

export default vouchers
